import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_KEY
)

// Realtime has its own auth track separate from REST. Without this, RLS on
// postgres_changes evaluates `auth.uid()` as NULL and silently drops every
// event before it reaches the `.on()` callback. onAuthStateChange fires
// INITIAL_SESSION on boot when a session is restored from storage, and again
// on every login/logout/refresh, so this keeps the websocket in sync.
supabase.auth.onAuthStateChange((_event, session) => {
  supabase.realtime.setAuth(session?.access_token ?? null)
})
